<div class="transference-page">

  <div class="page-intro">
    <b3-breadcrumbs aria-label="Breadcrumb">
      <b3-breadcrumbs-item variant="icon" href="/"></b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Operações de crédito</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Operações</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Transferir</b3-breadcrumbs-item>
    </b3-breadcrumbs>
    <h1 class="page-title">Transferir Créditos de Carbono</h1>
  </div>

  <form class="transference-form" [formGroup]="formTransference">
    <div class="form-layout">
      <div class="form-shell">
        <div class="section-block">
          <div class="section-header">
            <div class="section-header__title-group">
              <span class="section-header__accent" aria-hidden="true"></span>
              <h2 class="section-header__title">Dados do beneficiário</h2>
            </div>
            <b3-tag class="section-header__badge" size="sm" variant="filled" tone="info" label="Obrigatório"></b3-tag>
          </div>
          <div class="fields-row fields-row--2">
            <div class="field-group field-group--labeled">
              <b3-input-text
                formControlName="holderCode"
                inputId="holderCode"
                label="Detentor"
                background="white"
                mask="account"
                [error]="checkHasError('holderCode')"
                [hint]="[
                  { show: checkHasError('holderCode', 'required'), text: 'Campo obrigatório' },
                  { show: checkHasError('holderCode'), text: 'Preenchimento inválido' }
                ] | fieldHint"
                (b3-input)="onInstrumentFieldChange()"
                (b3-change)="onInstrumentFieldChange()">
              </b3-input-text>
            </div>
            <div class="field-group field-group--labeled tooltip-container">
              <b3-input-text
                formControlName="cpfCnpjComitente"
                inputId="cpfCnpjComitente"
                label="CPF/CNPJ do Detentor"
                [background]="showcpfCnpjComitente ? 'white' : 'grey'"
                [mask]="comitenteDocumentMask"
                placeholder="00.000.000/0000-00"
                [maxlength]="18"
                [error]="showcpfCnpjComitente && checkHasError('cpfCnpjComitente') && !comitenteFound"
                [hint]="[
                  { show: showcpfCnpjComitente && comitenteFound, text: 'Comitente encontrado para conta' },
                  { show: showcpfCnpjComitente && checkHasError('cpfCnpjComitente', 'required'), text: 'Campo obrigatório' },
                  { show: showcpfCnpjComitente && checkHasError('cpfCnpjComitente', 'comitenteInvalido'), text: 'Comitente não encontrado para esta conta' },
                  { show: showcpfCnpjComitente && checkHasError('cpfCnpjComitente'), text: 'CPF/CNPJ inválido' }
                ] | fieldHint"
                (b3-blur)="onChangesHolderComitenteCpfOrCnpj()">
              </b3-input-text>
              <ng-container *ngIf="showcpfCnpjComitente">
                <span class="tooltip-text">Preencha o CPF/CNPJ do comitente da conta 10</span>
              </ng-container>
            </div>
          </div>
          <div class="fields-row fields-row--2">
            <div class="field-group field-group--labeled">
              <b3-input-text
                formControlName="purchaserCode"
                inputId="purchaserCode"
                label="Adquirente"
                background="white"
                mask="account"
                [error]="checkHasError('purchaserCode')"
                [hint]="[
                  { show: checkHasError('purchaserCode', 'required'), text: 'Campo obrigatório' },
                  { show: checkHasError('purchaserCode', 'institutionalAccountNotAllowed'), text: 'A conta miolo 40 não deve ser aceita no ato da transferência, apenas a 00 ou 10' },
                  { show: checkHasError('purchaserCode'), text: 'Preenchimento inválido' }
                ] | fieldHint">
              </b3-input-text>
            </div>
            <div class="field-group field-group--labeled tooltip-container">
              <b3-input-text
                formControlName="purchaserComitenteDocument"
                inputId="purchaserComitenteDocument"
                label="CPF/CNPJ do Adquirente"
                [background]="showPurchaserComitenteDocument ? 'white' : 'grey'"
                [mask]="purchaserComitenteDocumentMask"
                placeholder="00.000.000/0000-00"
                [maxlength]="18"
                [error]="showPurchaserComitenteDocument && checkHasError('purchaserComitenteDocument') && !purchaserComitenteFound"
                [hint]="[
                  { show: showPurchaserComitenteDocument && purchaserComitenteFound, text: 'Comitente encontrado para conta' },
                  { show: showPurchaserComitenteDocument && checkHasError('purchaserComitenteDocument', 'required'), text: 'Campo obrigatório' },
                  { show: showPurchaserComitenteDocument && checkHasError('purchaserComitenteDocument', 'comitenteInvalido'), text: 'Comitente não encontrado para esta conta' },
                  { show: showPurchaserComitenteDocument && checkHasError('purchaserComitenteDocument'), text: 'CPF/CNPJ inválido' }
                ] | fieldHint"
                (b3-blur)="onChangesPurchaserComitenteCpfOrCnpj()">
              </b3-input-text>
              <ng-container *ngIf="showPurchaserComitenteDocument">
                <span class="tooltip-text">Preencha o CPF/CNPJ do comitente da conta 10 do adquirente</span>
              </ng-container>
            </div>
          </div>
        </div>

        <div class="section-block">
          <div class="section-header">
            <div class="section-header__title-group">
              <span class="section-header__accent" aria-hidden="true"></span>
              <h2 class="section-header__title">Dados do ativo</h2>
            </div>
            <b3-tag class="section-header__badge" size="sm" variant="filled" tone="info" label="Obrigatório"></b3-tag>
          </div>
          <div class="fields-row fields-row--2">
            <div class="field-group field-group--labeled">
              <b3-input-text
                formControlName="carbonCreditCode"
                inputId="carbonCreditCode"
                label="Código do instrumento"
                background="white"
                mask="instrument"
                placeholder=""
                [error]="checkHasError('carbonCreditCode')"
                [hint]="[
                  { show: checkHasError('carbonCreditCode', 'required'), text: 'Campo obrigatório' }
                ] | fieldHint"
                (b3-input)="onInstrumentFieldChange()"
                (b3-change)="onInstrumentFieldChange()">
              </b3-input-text>
            </div>
            <div class="field-group field-group--labeled field-group--quantity">
              <b3-input-text
                formControlName="creditQuantity"
                inputId="creditQuantity"
                label="Quantidade"
                background="white"
                mask="integer"
                placeholder="Apenas números inteiros"
                [error]="checkHasError('creditQuantity')"
                [hint]="[
                  { show: checkHasError('creditQuantity', 'required'), text: 'Campo obrigatório' },
                  { show: checkHasError('creditQuantity'), text: 'Preenchimento inválido' }
                ] | fieldHint"
                (b3-input)="onInstrumentFieldChange()"
                (b3-change)="onInstrumentFieldChange()">
              </b3-input-text>
            </div>
          </div>
          <div class="if-quantity-row" *ngIf="showInstrumentQuantity">
            <div class="if-quantity-info">
              <span class="if-quantity-info__label">Quantidade total do IF</span>
              <b3-tag
                class="if-quantity-badge"
                size="sm"
                variant="filled"
                tone="warning"
                [label]="'+ ' + instrumentAvailableQuantity + '/' + instrumentTotalQuantity"
                aria-live="polite">
              </b3-tag>
            </div>
          </div>
          <div class="if-quantity-row" *ngIf="remainingQuantity != null">
            <div class="if-quantity-info">
              <span class="if-quantity-info__label">Quantidade restante</span>
              <b3-tag
                class="if-quantity-badge"
                size="sm"
                variant="filled"
                tone="warning"
                [label]="'' + remainingQuantity"
                aria-live="polite">
              </b3-tag>
            </div>
          </div>
        </div>
      </div>

      <div class="aceite-card">
        <div class="section-header">
          <div class="section-header__title-group">
            <span class="section-header__accent" aria-hidden="true"></span>
            <h2 class="section-header__title">Aceite</h2>
          </div>
          <b3-tag class="section-header__badge" size="sm" variant="filled" tone="info" label="Obrigatório"></b3-tag>
        </div>
        <p class="aceite-text">
          Declaro estar ciente de que esta operação de transferência dos créditos de carbono é irreversível
          e não poderá ser desfeita após a confirmação.
        </p>
        <b3-checkbox
          class="aceite-card__confirm"
          label="Confirmar"
          [selected]="confirmation"
          (b3-change)="confirmationChange($event)">
        </b3-checkbox>
      </div>

      <div class="form-actions" role="group" aria-label="Ações do formulário">
        <b3-button
          type="button"
          variant="ghost"
          tone="default"
          class="form-actions__btn-cancel"
          (b3-click)="cleanForm()">
          Cancelar
        </b3-button>
        <b3-button
          type="button"
          variant="filled"
          tone="default"
          class="form-actions__btn-submit"
          [disabled]="!canSubmit"
          (b3-click)="transferenceRegister()">
          <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
          Transferir
        </b3-button>
      </div>
    </div>
  </form>

  <footer class="page-footer">
    <p class="page-footer__text">B3SA© 2026 Plataforma de Carbono. Todos os direitos reservados.</p>
  </footer>
</div>

<app-modal-success-transference
  *ngIf="transferenceResultModal"
  [open]="showTransferenceResultModal"
  [viewModel]="transferenceResultModal"
  (action)="onTransferenceResultModalAction($event)">
</app-modal-success-transference>
